
import { useContext, useState, createContext, useEffect } from 'react';

const defualtValue = {};

// initialize user context
const PreferenceContextValue = createContext(defualtValue);
const PreferenceContextSetState = createContext(() => null);

function PreferenceProvider({ children, preference = defualtValue }) {
  const [_preference, setPreference] = useState(preference);

  useEffect(() => {
    setPreference(preference);
  }, [preference]);
  return (
    <PreferenceContextValue.Provider value={_preference}>
      <PreferenceContextSetState.Provider value={setPreference}>{children}</PreferenceContextSetState.Provider>
    </PreferenceContextValue.Provider>
  );
}

function usePreferenceState() {
  const preference = useContext(PreferenceContextValue);
  const setPreference = useContext(PreferenceContextSetState);
  const state = [preference, setPreference];
  return state;
}

function usePreferenceValue() {
  const preference = useContext(PreferenceContextValue);
  return preference;
}

function usePreferenceSetState() {
  const setPreference = useContext(PreferenceContextSetState);
  return setPreference;
}

export { PreferenceProvider, usePreferenceState, usePreferenceValue, usePreferenceSetState };
